<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.ReceiptHistory')"
    width="1000px"
    :close-on-click-modal="false"
    class="app-main-inner"
  >
    <cargo-ag-grid
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      style="width:100%;height:300px"
      @gridReady="params=>{gridApi=params.api}"
    />
    <span slot="footer">
      <el-button @click="innerVisible=false">{{ $t('common.btn.close') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { CheckCargoDocHistory } from '@/class/model/booking/CheckCargoDocHistory'

export default {
  name: 'ReceiptHistoryDialog',
  props: {
    visible: { type: Boolean, required: true },
    jobUuid: { type: String, required: true }
  },
  data() {
    return {
      innerVisible: false,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_ChineseFirstVesselName'),
          field: 'vessel',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_VoyageNo'),
          field: 'voyageFlight',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_SailingDate'),
          field: 'etd',
          width: 100
        }, {
          headerName: 'MBL',
          field: 'mbl',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_TransitTerm'),
          field: 'freightTerm',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_PaymentMethod'),
          field: 'paymentTermMBL',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_PortOfLoading'),
          field: 'loadingPortCode',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_DestinationPort'),
          field: 'destinationPortCode',
          width: 100
        }, {
          headerName: this.$t('SeaExport.PortOfFinalDestination'),
          field: 'destinationPlace',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_ItemsNBR'),
          field: 'quantityActual',
          width: 100
        }, {
          headerName: this.$t('SeaExport.Weight'),
          field: 'weightActual',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_Cubage'),
          field: 'cubageActual',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_Package'),
          field: 'packing',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_Shipper'),
          field: 'shipperCode',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_Consignee'),
          field: 'consigneeCode',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_NotifyParty'),
          field: 'notifyCode',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_EnglishCargoName'),
          field: 'cargoEnglishName',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_Marks'),
          field: 'mark',
          width: 100
        }
      ],
      rowData: [],
      gridApi: null
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.toQuery()
    }
  },
  methods: {
    toQuery() {
      if (this.jobUuid) {
        CheckCargoDocHistory.queryReceiptHistory(this.jobUuid).then(data => {
          this.rowData = data
        })
      } else {
        this.rowData = []
      }
    }
  }
}
</script>

<style>
</style>
